import { render, staticRenderFns } from "./ChatBoxFlexCarousel.vue?vue&type=template&id=10aef630&scoped=true"
import script from "./ChatBoxFlexCarousel.vue?vue&type=script&lang=js"
export * from "./ChatBoxFlexCarousel.vue?vue&type=script&lang=js"
import style0 from "./ChatBoxFlexCarousel.vue?vue&type=style&index=0&id=10aef630&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10aef630",
  null
  
)

export default component.exports